// components
import { LAYOUT_DEFAULT } from "../components/layouts";

export default function PAGE_TICKETS () {
    return (
        <LAYOUT_DEFAULT pageName={ "tickets" }>
            <section>Tickets</section>
        </LAYOUT_DEFAULT>
    )
}